import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MusicToggle from './components/MusicToggle';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PromoPage from './pages/PromoPage';
import PackagesPage from './pages/PackagesPage';
import PpdppPage from './pages/PpdppPage';

// Shared chrome (Header + Footer) for the public site.
const SiteLayout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <MusicToggle />
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);
// Note: the floating dock is fixed/overlaid, so the hero handles its own top
// spacing; non-hero pages add their own pt-* to clear the dock.

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public site (with shared Header/Footer) */}
        <Route path="/" element={<SiteLayout><HomePage /></SiteLayout>} />
        <Route path="/about" element={<SiteLayout><AboutPage /></SiteLayout>} />
        <Route path="/contact" element={<SiteLayout><ContactPage /></SiteLayout>} />
        <Route path="/promo" element={<SiteLayout><PromoPage /></SiteLayout>} />
        {/* PPD Petaling Perdana event (QR on final CTA slide), Okt 2026 */}
        <Route path="/ppdpp" element={<SiteLayout><PpdppPage /></SiteLayout>} />

        {/* Standalone sales page — its own nav, no shared chrome */}
        <Route path="/packages" element={<PackagesPage />} />
      </Routes>
    </Router>
  );
};

export default App;